// import { ConnectedProvider } from './../providers/connected/connected';
import { ClinicalUpdatesProvider } from './../providers/clinical-updates/clinical-updates';

import { AuthProvider } from './../providers/auth/auth';
import { Component, ViewChild } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AnalyticsService } from '../services/analytics.service';
import { MainService } from '../services/main.service';
import { PageIndicatorsService } from '../services/page-indicators.service';
// import { Keyboard } from '@ionic-native/keyboard';

@Component({
	templateUrl: 'app.html'
})
export class MyApp {

	@ViewChild('nav') nav: NavController;
	rootPage: any = 'EntryPage';

	constructor(
		private platform: Platform,
		private statusBar: StatusBar,
		private splashScreen: SplashScreen,
		// private keyboard: Keyboard,
		public authProvider: AuthProvider,
		public clinicalUpdatesProvider: ClinicalUpdatesProvider,
		// private connectedProvider: ConnectedProvider,
		private analyticsService: AnalyticsService,
		private mainService: MainService,
		private pageIndicatorsService: PageIndicatorsService
	) {
		this.platform.ready().then(() => {
			if (this.platform.is('cordova')) {
				// set status bar to light style
				this.statusBar.styleLightContent();

				// hide splash screen
				this.splashScreen.hide();

				// show done button on keyboard
				//this.keyboard.hideKeyboardAccessoryBar(false);
			}

			this.analyticsService.startGoogleAnalytics();
			this.pageIndicatorsService.init();
		});
	}

	ngAfterViewInit(): void {
		this.mainService.rootNavController = this.nav;
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts